import InviteAdmin from "./InviteAdmin";
export default InviteAdmin;
